import { useEffect, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { autoCompleteDelay } from '../../Config';
import { FetchAutoCompleteData } from './Common';

export const InputBox = (props) => {

    let { label = '', required = false, id, type = 'text', placeholder, onChange, onKeyDown, value, disabled = false, format = false } = props;

    return (
        <>
            <div className="mb-2">
                {
                    label !== '' &&

                    <label
                        className="mb-1 block text-sm font-medium text-gray-900">
                        {label} {required && <span className='text-red-500'>*</span>}
                    </label>
                }
                {type === 'time' ? (
                    <DatePicker
                        selected={value ? (() => {
                            const [hours, minutes] = value.split(':');
                            const date = new Date();
                            date.setHours(parseInt(hours, 10) || 0);
                            date.setMinutes(parseInt(minutes, 10) || 0);
                            return date;
                        })() : null}
                        onChange={(date) => {
                            if (date && onChange) {
                                const hours = String(date.getHours()).padStart(2, '0');
                                const minutes = String(date.getMinutes()).padStart(2, '0');
                                onChange({ target: { value: `${hours}:${minutes}` } });
                            } else if (onChange) {
                                onChange({ target: { value: '' } });
                            }
                        }}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={15}
                        timeCaption="Time"
                        dateFormat="HH:mm"
                        timeFormat="HH:mm"
                        id={id}
                        disabled={disabled}
                        placeholderText={placeholder || "HH:mm"}
                        className="block w-full rounded-lg border border-gray-300 bg-gray-50 px-2.5 py-1.5 text-sm text-gray-900 focus:ring-blue-500 focus:border-blue-500 focus:outline-none 2xl:py-2.5 2xl:px-2.5"
                        onKeyDown={onKeyDown}
                        autoComplete="off"
                        onChangeRaw={(e) => {
                            let val = e.target.value;
                            val = val.replace(/[^0-9:]/g, '');
                            if (val.length === 2 && !val.includes(':') && e.nativeEvent?.inputType !== 'deleteContentBackward') {
                                val = val + ':';
                            }
                            e.target.value = val;
                        }}
                    />
                ) : (
                    <input
                        id={id}
                        type={type}
                        disabled={disabled}
                        placeholder={placeholder}
                        className="block w-full rounded-lg border border-gray-300 bg-gray-50 px-2.5 py-1.5 text-sm text-gray-900 focus:ring-blue-500 focus:border-blue-500 focus:outline-none 2xl:py-2.5 2xl:px-2.5"
                        onKeyDown={onKeyDown}
                        value={value}
                        onChange={onChange}
                    />
                )}
                {
                    format &&
                    <>
                        <span className='text-red-500'>format</span> (24:00)
                    </>
                }
            </div>
        </>

    )
}

export const Switch = (props) => {

    const { id, checked = false, onKeyDown, label, customstyle, onClick,
        extraclassname = `form-check form-switch`,
        onChange } = props

    return (
        <>
            <div className="mb-2 flex items-end pb-3">
                <label className="inline-flex items-center me-5 cursor-pointer">
                    <input
                        type="checkbox"
                        id={id}
                        checked={checked}
                        onChange={onChange}
                        onKeyDown={onKeyDown}
                        onClick={onClick}
                        value=""
                        class="sr-only peer"
                    />
                    <div className="relative w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-2 peer-focus:ring-green-300 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[4.5px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4  after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-green-600"></div>
                    <span className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">{label ? label : ''}</span>
                </label>
            </div>

        </>
    )
}
//<div className={` ${divclassname}`} key={`checkin${id}`}>
//    <div className={`${extraclassname}`} >
//        <input
//            style={customstyle}
//            className="form-check-input"
//            type="checkbox"
//            id={id}
//            checked={checked}
//            onChange={onChange}
//            onKeyDown={onKeyDown}
//            onClick={onClick}
//            //    ref={ref => (inputrefs.current[id] = ref)}
//            {...props}
//        />
//        {label && <label className="form-check-label" htmlFor={id}>{label}</label>}
//    </div>
//</div>
export const SelectInputBox = (props) => {
    const { onKeyDown, divstyle, inputstyle, id, label = '', value, onChange, children, disabled = false, required } = props
    return (
        <>
            <div
                className="mb-1"
                style={divstyle}
            >
                {label === '' ? '' :
                    <label
                        htmlFor={id}
                        className="mb-1 block text-sm font-medium text-gray-900"
                    >{label}
                        {required && <span className='text-red-500'>*</span>}
                    </label>
                }
                <select
                    id={id}
                    className="block w-full h-[34px] 2xl:h-[42px] rounded-lg border border-gray-300 bg-gray-50 px-2.5 py-1.5 text-sm text-gray-900 focus:ring-blue-500 focus:border-blue-500 focus:outline-none 2xl:py-2.5 2xl:px-2.5"
                    style={inputstyle}
                    onKeyDown={onKeyDown}
                    value={value}
                    disabled={disabled}
                    onChange={onChange}
                    title={required ? 'Please select an item in the list.' : ''}
                    autoComplete="off"
                    {...props}
                >
                    {children}
                </select>
            </div>
        </>
    )
}

export const DateBox = (props) => {
    const { divclassname = "",
        label = '',
        disabled = false,
        onKeyDown,
        selected, placeholder, id, onFocus, onChange, required, inputclassname, divstyle, InfoDetails, preventOpenOnFocus = true } = props;
    return (
        <div className={`mb-1 ${divclassname}`} style={divstyle}>
            <div>
                {label === '' ? '' :
                    <label
                        className="mb-1 block text-sm font-medium text-gray-900"
                        title={label}>{label}
                        {required && <span className='text-red-500'>*</span>}
                    </label>
                }
                <DatePicker
                    id={id}
                    className="block w-full rounded-lg border border-gray-300 bg-gray-50 px-2.5 py-1.5 text-sm text-gray-900 focus:ring-blue-500 focus:border-blue-500 focus:outline-none 2xl:py-2.5 2xl:px-2.5"
                    dateFormat="dd-MMM-yyyy"
                    placeholderText={placeholder}
                    selected={selected}
                    onFocus={onFocus}
                    onKeyDown={onKeyDown}
                    disabled={disabled}
                    // inputrefs={inputrefs.current[id]}
                    //isClearable={true}
                    //selectsRange={true}
                    //monthsShown={3 }
                    // onMonthChange={() => { }}
                    showYearDropdown={true}
                    showMonthDropdown={true}
                    dropdownMode="select"
                    dateFormatCalendar=" "
                    //  selectsStart={true }
                    //inline={true }
                    //showIcon={true }
                    //autoFocus={true }
                    //closeOnScroll={true}
                    // showFullMonthYearPicker={true }
                    //  showTwoColumnMonthYearPicker={true }
                    // onDayMouseEnter
                    // focusSelectedMonth={true }
                    //todayButton={true }
                    yearDropdownItemNumber={50}
                    scrollableYearDropdown={true}
                    preventOpenOnFocus={true}
                    onChange={onChange}
                    autoComplete="off"
                    title={required ? 'Please fill this field.' : ''}
                    {...props}
                />
            </div>
        </div>
    )
}

export const AutoCompleteBoxNew = (props) => {
    const { divclassname = "col-lg-2 col-md-3 col-sm-6 pe-0", onKeyDown, style, divstyle, inputstyle, inputrefs, maxLength, label, nextFocus = ''
        , error, required, value, InfoDetails, autocompleteType = '', contextKey = '', contextKey2 = '', contextKey3 = '', contextKey4 = '', contextKey5 = '', renderinput = null,
        Options, isLocalOption = false, placeholder, disabled, ...restProps } = props;

    const { id, multiple = false } = restProps

    const autoCompleteTimeoutRef = useRef(null);
    const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
    const [inputValue, setInputValue] = useState(value);
    useEffect(() => {
        setInputValue(value);
    }, [value]);

    const handleAutoCompleteChange = (event, prefix) => {
        if (isLocalOption) {
            setAutoCompleteOptions(Options ? Options : []);
        } else {
            if (autoCompleteTimeoutRef.current) {
                clearTimeout(autoCompleteTimeoutRef.current);
            }
            autoCompleteTimeoutRef.current = setTimeout(async () => {
                const autoOptions = await FetchAutoCompleteData(autocompleteType, prefix, contextKey, contextKey2, contextKey3, contextKey4, contextKey5);
                setAutoCompleteOptions(autoOptions ? autoOptions : []);
            }, autoCompleteDelay);
        }
    };


    return (
        <div className={`fields `} style={divstyle || style}>
            {label === '' ? '' :
                <label
                    className="mb-1 block text-sm font-medium text-gray-900"
                    title={label}>{label}
                    {required && <span className='text-red-500'>*</span>}
                </label>
            }
            <Autocomplete
                value={inputValue}
                freeSolo
                className="p-0"
                multiple={multiple}
                autoComplete
                autoSelect={true}
                disabled={disabled}
                autoHighlight={false}
                selectOnFocus={true}
                includeInputInList
                filterOptions={(x) => x}
                options={autoCompleteOptions}
                isOptionEqualToValue={(option, value) => multiple && option === value}
                onInputChange={
                    (event, newInputValue, reason) => {
                        if (reason && newInputValue && reason === 'input') {
                            handleAutoCompleteChange(event, newInputValue);
                        }
                        else {
                            if (autoCompleteOptions) {
                                setAutoCompleteOptions([]);
                            }
                        }
                    }}
                onClose={(event, reason) => {
                    if (autoCompleteOptions) {
                        setAutoCompleteOptions([]);

                    }
                }}
                title={required ? 'Please fill this field.' : ''}
                renderInput={(params) => <TextField
                    {...params}
                    onInput={(e) => {
                        const { value } = e.target;
                        if (value.length > maxLength) {
                            e.target.value = value.slice(0, maxLength);
                        }
                    }}
                    id={id}
                    sx={inputstyle}
                    placeholder={placeholder ? placeholder : label}
                    onKeyDown={onKeyDown}
                    autoComplete="off"
                />}
                {...restProps}
            />
            {renderinput}
            {error && inputValue === "" && <div className="error-msg">{error}</div>}
        </div>
    )
}
export const CustomButton = ({ id, label, onClick, color, size = 'sm', icon: Icon, children, additionalClasses = '' }) => {

    const colorClasses = {
        yellow: 'bg-yellow-400 text-zinc-800 shadow-lg shadow-yellow-100',
        red: 'bg-red-600 text-white shadow-lg shadow-red-200',
        green: 'bg-green-600 text-white shadow-lg shadow-green-200',
        brown: 'bg-orange-800 text-white shadow-lg shadow-orange-200'
    };

    const hasCustomPadding = additionalClasses.includes('px-');
    const sizeClasses = {
        sm: `${hasCustomPadding ? '' : 'px-8'} py-2 text-sm`,
    };

    return (
        <button
            id={id}
            onClick={onClick}
            className={`m-0 flex items-center justify-center ${Icon ? 'gap-1.5' : ''} rounded-full ${colorClasses[color] || colorClasses.yellow} ${sizeClasses[size]} ${additionalClasses} font-semibold leading-none`}
        >
            {Icon && <Icon className="w-4 h-4" />}
            {children || label}
        </button>
    );
};